import { collection, addDoc, getDocs, query, doc, updateDoc, getDoc, deleteDoc } from 'firebase/firestore';
import { db } from './firebase';
import { ensureUserExists } from './firebase';

// Admin user data
const adminUser = {
  email: "admin@pizzaveg.it",
  password: "admin123!",
  role: "admin",
  name: "Admin PizzaVeg"
};

const clearCollection = async (collectionName: string) => {
  console.log(`Clearing ${collectionName} collection...`);
  const snapshot = await getDocs(collection(db, collectionName));
  const deletePromises = snapshot.docs.map(doc => deleteDoc(doc.ref));
  await Promise.all(deletePromises);
  console.log(`${collectionName} collection cleared`);
};

export const seedDatabase = async () => {
  try {
    console.log('Starting database seeding...');
    
    // Clear existing data
    await clearCollection('pizze');
    await clearCollection('pizzerie');
    await clearCollection('pizzeinmenu');
    await clearCollection('sliceTransactions');
    
    // Create admin user
    console.log('Creating admin user...');
    try {
      await ensureUserExists(adminUser);
      console.log(`Admin user ${adminUser.email} processed`);
    } catch (error) {
      console.error('Error processing admin user:', error);
      throw error;
    }

    // Add a test pizza
    console.log('Creating test pizza...');
    try {
      const pizzaData = {
        name: "Margherita Vegana",
        description: "La classica pizza napoletana in versione vegana con mozzarella di soia",
        ingredients: ["Pomodoro", "Mozzarella di soia", "Basilico", "Olio EVO"],
        imageUrl: "https://pizzaveg.it/materiale/pizze/margherita-veg.jpg",
        pizzerias: [],
        createdAt: new Date().toISOString()
      };

      const pizzaRef = await addDoc(collection(db, 'pizze'), pizzaData);
      console.log(`Added test pizza with ID: ${pizzaRef.id}`);

      // Add a test pizzeria
      console.log('Creating test pizzeria...');
      const pizzeriaData = {
        name: "VegPizza Roma Centro",
        description: "Pizzeria 100% vegana nel cuore di Roma",
        address: "Via del Corso 123",
        city: "Roma",
        lat: 41.9028,
        lng: 12.4964,
        imageUrl: "https://pizzaveg.it/materiale/pizzerie/roma-centro.jpg",
        email: "roma.centro@pizzaveg.it",
        phone: "+39 06 1234567",
        isVerified: true,
        pizzas: [pizzaRef.id],
        createdAt: new Date().toISOString()
      };

      const pizzeriaRef = await addDoc(collection(db, 'pizzerie'), pizzeriaData);
      console.log(`Added test pizzeria with ID: ${pizzeriaRef.id}`);

      // Add pizza to menu with expiration
      await addDoc(collection(db, 'pizzeinmenu'), {
        pizzeriaId: pizzeriaRef.id,
        pizzaId: pizzaRef.id,
        addedAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
      });

      // Update pizza with pizzeria reference
      await updateDoc(pizzaRef, {
        pizzerias: [pizzeriaRef.id]
      });
      console.log('Updated test pizza with pizzeria reference');

    } catch (error) {
      console.error('Error adding test data:', error);
      throw error;
    }

    console.log('Database seeded successfully!');
    return true;
  } catch (error) {
    console.error('Error seeding database:', error);
    throw error;
  }
};